<template>
  <div>
    <v-select
      :items="localFlows"
      v-model="flow"
      :label="$t('flow')"
      item-text="display"
      item-value="id"
      :append-icon="$flow.isAllowed('create') ? $vuetify.icons.values.addCircleInverted : null"
      @click:append="create"
      :error-messages="errors"
      required
      :readonly="readonly"
    />
    <router-view></router-view>
  </div>
</template>

<script>
import { differenceBy } from 'lodash/array'
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import flowPerimeter from '../perimeters.js'

export default {
  name: 'FlowField',
  perimeters: [flowPerimeter],
  props: {
    flowId: Number,
    typeFilter: String,
    setFlowId: { type: Function, required: true },
    errors: { type: Array, default: () => [] },
    flowLink: { type: String, default: 'nestedNewFlow' },
    returnLink: { type: String, default: 'newBoard' }
  },
  computed: {
    ...mapState(NAMESPACE, ['flows']),
    localFlows() {
      return this.typeFilter ? this.flows.filter((item) => item.meta.entity_type === this.typeFilter) : this.flows
    },
    readonly() {
      return this.localFlows.length === 1
    },
    flow: {
      get() {
        return this.flowId
      },
      set(v) {
        this.setFlowId(v)
      }
    }
  },
  watch: {
    localFlows: function (newItems, previousItems) {
      if (newItems && newItems.length === 1) {
        this.setFlowId(newItems[0].id)
      }
      return
      let added = differenceBy(newItems, previousItems, 'id')[0]
      if (added && this.flow !== added.id) {
        this.setFlowId(added.id)
      }
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listFlows', 'clearFlows']),
    create() {
      this.$router.push({ name: this.flowLink, params: { ...this.$route.params, returnLink: this.returnLink } })
    }
  },
  created() {
    this.listFlows({})
  },
  destroyed() {
    this.clearFlows().catch(() => {})
  }
}
</script>

<i18n>
{
  "en": {
    "flow": "@:labels.flow"
  },
  "fr": {
    "flow": "@:labels.flow"
  }
}
</i18n>
